module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<label class="block hover-effect-wrapper"><input class="hover-effect-enabled" type="checkbox"><span class="custom-checkbox"> </span>Mouseover Effect</label>\n<div class="hover-region"></div>\n\n<label class="block attention-effect-wrapper"><input class=" attention-effect-enabled" type="checkbox"><span class="custom-checkbox"></span>Loop Effect</label>\n<div class="attention-region"></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/EffectsView.tpl
// module id = 1752
// module chunks = 0